import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

export const TrackPageView = () => {
  const location = useLocation();

  useEffect(() => {
    globalThis.dataLayer?.push({
      event: 'virtual_page_view',
      pageURL: globalThis.location.href,
    });
  }, [location]);

  return <Outlet />;
};
